import { useEffect } from "react";
import { Card, Empty, Spin, Table, Tabs, Typography } from "antd";
import { useHuulga } from "../../../huulga/useHuulga";

const { TabPane } = Tabs;

const yearColumn = {
  title: "Он",
  dataIndex: "year",
  key: "year",
  width: 70,
  render: (year: number) => <Typography.Text strong>{year}</Typography.Text>,
};

const orlogoZarlagaColumns = [
  yearColumn,
  { title: "Огноо", dataIndex: "date", key: "date", width: 180 },
  { title: "Орлого", dataIndex: "income", key: "income", width: 150 },
  { title: "Зарлага", dataIndex: "expense", key: "expense", width: 150 },
  { title: "Тайлбар", dataIndex: "description", key: "description" },
  {
    title: "Цэнэглэсэн огноо / Данс",
    dataIndex: "depositDate",
    key: "depositDate",
    width: 200,
  },
];

const hudaldanAvaltColumns = [
  yearColumn,
  { title: "Огноо", dataIndex: "date", key: "date", width: 180 },
  { title: "Мөнгөн дүн", dataIndex: "amount", key: "amount", width: 130 },
  { title: "Багц №", dataIndex: "batchNo", key: "batchNo", width: 80 },
  { title: "Bond", dataIndex: "bond", key: "bond", width: 120 },
  { title: "Estate", dataIndex: "estate", key: "estate", width: 100 },
  {
    title: "Худалдан авалтаас үлдсэн дүн",
    dataIndex: "lockAmount",
    key: "lockAmount",
    width: 150,
  },
  { title: "FX", dataIndex: "fx", key: "fx", width: 80 },
  { title: "DIA", dataIndex: "dia", key: "dia", width: 80 },
  { title: "VDE", dataIndex: "vde", key: "vde", width: 80 },
  { title: "VUG", dataIndex: "vug", key: "vug", width: 80 },
  { title: "VXF", dataIndex: "vxf", key: "vxf", width: 80 },
];

const buitsaaltColumns = [
  yearColumn,
  {
    title: "Тооцоолсон огноо",
    dataIndex: "calcDate",
    key: "calcDate",
    width: 140,
  },
  {
    title: "Хөрөнгийн нэр",
    dataIndex: "assetName",
    key: "assetName",
    width: 140,
  },
  { title: "Үндсэн дүн", dataIndex: "principal", key: "principal", width: 120 },
  {
    title: "Бонд хүү",
    dataIndex: "bondInterest",
    key: "bondInterest",
    width: 100,
  },
  { title: "Хүү тооцох хоног", dataIndex: "days", key: "days", width: 120 },
  {
    title: "Тооцсон хүү",
    dataIndex: "calcInterest",
    key: "calcInterest",
    width: 120,
  },
  { title: "Нийт", dataIndex: "total", key: "total", width: 120 },
  {
    title: "AvtaMata шимтгэл",
    dataIndex: "avtamataFee",
    key: "avtamataFee",
    width: 140,
  },
  {
    title: "Арилжааны шимтгэл",
    dataIndex: "tradingFee",
    key: "tradingFee",
    width: 140,
  },
  { title: "ОАТ", dataIndex: "tax", key: "tax", width: 80 },
  {
    title: "Шилжүүлэх дүн",
    dataIndex: "transferAmount",
    key: "transferAmount",
    width: 130,
  },
  { title: "Данс", dataIndex: "account", key: "account", width: 130 },
];

export const HuulgaTab = ({ email }: { email?: string | null }) => {
  const { loading, dataLoading, result, error, search } = useHuulga();
  useEffect(() => {
    if (!dataLoading && email) {
      search(email);
    }
  }, [dataLoading, email, search]);

  if (!email) {
    return (
      <Card>
        <Empty description="Хэрэглэгчийн имейл хаяг байхгүй байна" />
      </Card>
    );
  }

  if (dataLoading || loading) {
    return (
      <Card>
        <div style={{ textAlign: "center", padding: 32 }}>
          <Spin tip="Хуулга мэдээлэл ачаалж байна..." />
        </div>
      </Card>
    );
  }

  if (error || !result) {
    return (
      <Card>
        <Empty description={error || "Хуулга мэдээлэл олдсонгүй"} />
      </Card>
    );
  }

  return (
    <Tabs defaultActiveKey="oz" type="card">
      <TabPane tab={`Орлого зарлага (${result.orlogoZarlaga.length})`} key="oz">
        <Table
          dataSource={result.orlogoZarlaga}
          columns={orlogoZarlagaColumns}
          size="small"
          bordered
          pagination={false}
          scroll={{ x: 1000 }}
        />
      </TabPane>

      <TabPane tab={`Худалдан авалт (${result.hudaldanAvalt.length})`} key="ha">
        <Table
          dataSource={result.hudaldanAvalt}
          columns={hudaldanAvaltColumns}
          size="small"
          bordered
          pagination={false}
          scroll={{ x: 1200 }}
        />
      </TabPane>

      <TabPane tab={`Буцаалт (${result.buitsaalt.length})`} key="bu">
        <Table
          dataSource={result.buitsaalt}
          columns={buitsaaltColumns}
          size="small"
          bordered
          pagination={false}
          scroll={{ x: 1500 }}
        />
      </TabPane>
    </Tabs>
  );
};
